import { getConfigFor } from '../../../../utils/configService'
import { SPLIT_FEATURES } from '../../../../utils/constants/feature'
import { AnalyticsEvent } from '../../core/AnalyticsEvent'
import { BannerViewedEventSchema } from '../../schemas/banner/BannerViewedEventSchema'
import { CommonEventParams, getCommonParams } from '../../utils/CommonParams'
import { BannerContentInterface } from './BannerClickedEvent'

export interface BannerViewedEventParams extends CommonEventParams {
  BUSINESS_VERTICAL: string
  EVENT_CATEGORY: string
  CONTENT: BannerContentInterface
}

export class BannerViewedEvent extends AnalyticsEvent {
  constructor(params: BannerViewedEventParams) {
    super(BannerViewedEventSchema, ['segment'])
    this.createEventObject(params)
  }
}

export function trackBannerViewedEvent(params: BannerViewedEventParams) {
  const { isEnabled = false } =
    getConfigFor(SPLIT_FEATURES.LEAP_CDP_RELEASE_FIVE) || {}
  if (isEnabled) {
    const commonParams = getCommonParams()
    const bannerViewEventParams = {
      ...params,
      ...commonParams
    }
    new BannerViewedEvent(bannerViewEventParams).track()
  }
}
